import { useEffect } from "react";

export function SaleContextMountHost() {
  useEffect(() => {
    let ownedMount: HTMLDivElement | null = null;

    const ensureMount = () => {
      const panel = document.querySelector<HTMLElement>(".sale-cart-panel");
      if (!panel) return;

      const existing = panel.querySelector<HTMLDivElement>(":scope > .sale-context-mount");
      if (existing) {
        ownedMount = existing;
        return;
      }

      const mount = document.createElement("div");
      mount.className = "sale-context-mount";
      mount.setAttribute("aria-label", "สมาชิกและสิทธิ์การขาย");
      panel.appendChild(mount);
      ownedMount = mount;
    };

    ensureMount();
    const observer = new MutationObserver(ensureMount);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (ownedMount?.isConnected) ownedMount.remove();
    };
  }, []);

  return null;
}
